// extracted by mini-css-extract-plugin
module.exports = {"tabGroupContainer":"Tab-Group--tabGroupContainer--3cJVd","tabNavShadowContainer":"Tab-Group--tabNavShadowContainer--2Jhky","tabNavShadow":"Tab-Group--tabNavShadow--214Ne"};